import { create } from "zustand";
import { Contact } from "../interfaces/DTO/crm/contact";

type ViewedType = "FAMILY" | "USER" | null;

interface ViewedTypeStore {
  viewedType: ViewedType;
  setViewedType: (type: ViewedType) => void;
}

export const useViewedTypeStore = create<ViewedTypeStore>((set, get) => ({
  viewedType: null, // ערך התחלתי
  setViewedType: (type) => {
    // ✅ רק מעדכן אם הערך באמת השתנה
    if (get().viewedType !== type) {
      set({ viewedType: type });
    }
  },
}));
interface IdStore {
  id: number | null;
  setId: (id: number | null) => void;
}

export const useIdStore = create<IdStore>((set, get) => ({
  id: null, // ערך התחלתי
  setId: (id) => {
    // ✅ רק מעדכן אם הערך באמת השתנה
    if (get().id !== id) {
      set({ id });
    }
  },
}));

interface RelatedContactsStore {
  relatedContacts: Contact[];
  setRelatedContacts: (contacts: Contact[]) => void;
}

export const useRelatedContactsStore = create<RelatedContactsStore>((set) => ({
  relatedContacts: [], // ערך התחלתי
  setRelatedContacts: (contacts) => set({ relatedContacts: contacts }),
}));

// Store for frozen presentation mode state
interface PresentationModeStore {
  presentationInitialId: number | null;
  presentationInitialType: ViewedType;
  presentationRelatedContacts: Contact[];
  setPresentationState: (id: number | null, type: ViewedType, contacts: Contact[]) => void;
  clearPresentationState: () => void;
}

export const usePresentationModeStore = create<PresentationModeStore>((set) => ({
  presentationInitialId: null,
  presentationInitialType: null,
  presentationRelatedContacts: [],
  setPresentationState: (id, type, contacts) => {
    set({
      presentationInitialId: id,
      presentationInitialType: type,
      presentationRelatedContacts: contacts ?? []
    });
  },
  clearPresentationState: () => {
    set({
      presentationInitialId: null,
      presentationInitialType: null,
      presentationRelatedContacts: []
    });
  },
}));

